export default "__VITE_ASSET__BxcfIpeB__"